export default {
  component: () => import('./page.vue'),
  path: '/family/:familyId/member/:memberId',
  name: 'member',
  meta: {
    title: '成员信息',
    auth: true,
  },
};
